import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];
  private readonly maxHistorySize = 50;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
        if (this.history.length > this.maxHistorySize) {
          this.history.shift();
        }
      });
  }

  goBack(): void {
    if (this.history.length > 1) {
      this.history.pop();
      const previousUrl = this.history.pop();
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['/']);
    }
  }

  canGoBack(): boolean {
    return this.history.length > 1;
  }

  getHistory(): string[] {
    return [...this.history];
  }
}
